import type { ExamSection, QuestionType } from '@examflow/core';
import { createSectionConstraint } from '@examflow/core';
import { JLPTSection } from './types';
import {
  jlptVocabularyDefinition,
  jlptGrammarReadingDefinition,
  jlptListeningDefinition,
} from './questionTypes';

/**
 * JLPT 语言知识（文字·词汇）配置
 * name：运营中文主文案 + 官方原文（见 sectionDisplayName.ts）
 */
export const JLPT_VOCABULARY_SECTION: ExamSection = {
  id: JLPTSection.VOCABULARY,
  name: '语言知识·文字词汇 (言語知識・文字・語彙)',
  duration: 25, // N2 级别参考时长
  /** N2-scale vocabulary section size for platform full mock. */
  questionCount: 35,
  questionTypes: ['single_choice' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(jlptVocabularyDefinition.id)],
};

/**
 * JLPT 语言知识（语法）·阅读配置
 */
export const JLPT_GRAMMAR_READING_SECTION: ExamSection = {
  id: JLPTSection.GRAMMAR_READING,
  name: '语言知识·语法与阅读 (言語知識・文法・読解)',
  duration: 105, // N2 级别参考时长
  /** N2-scale combined grammar + reading item count for platform full mock. */
  questionCount: 55,
  questionTypes: ['single_choice' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(jlptGrammarReadingDefinition.id)],
};

/**
 * JLPT 听力配置
 */
export const JLPT_LISTENING_SECTION: ExamSection = {
  id: JLPTSection.LISTENING,
  name: '听力 (聴解)',
  duration: 50, // N2 级别参考时长
  /** N2-scale listening item count for platform full mock. */
  questionCount: 35,
  questionTypes: ['single_choice' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(jlptListeningDefinition.id)],
};

/**
 * JLPT 必考部分（3项）
 */
export const JLPT_SECTIONS: ExamSection[] = [
  JLPT_VOCABULARY_SECTION,
  JLPT_GRAMMAR_READING_SECTION,
  JLPT_LISTENING_SECTION,
];

/**
 * 获取部分配置
 */
export function getJLPTSection(sectionId: JLPTSection): ExamSection | undefined {
  return JLPT_SECTIONS.find((s) => s.id === sectionId);
}

/**
 * 获取总考试时长（分钟）
 */
export function getTotalDuration(): number {
  return JLPT_SECTIONS.reduce((sum, section) => sum + section.duration, 0);
}
